import type {ReactElement} from 'react';
import React from 'react';
import {hideLoadingAction, LoadingVariant} from './loading-toast-reducer';
import {useAppDispatch, useAppSelector} from '@/hooks';
import {useIsMounted} from '@Hooks/useIsMounted';
import {ToastType} from '@Components/toast/toast.types';
import Toast from '@Components/toast';
import styles from './loading-toast.module.scss';
import {LOADER_COLOR} from '@Components/circular-progress-loader';

export function LoadingToast(): ReactElement<any> {
  const loadingToast = useAppSelector((state) => {
    return state.loadingToast;
  });
  const currentLoading = useAppSelector((state) => {
    return state.loadingToast.currentLoading;
  });
  const isSaveReminderDisplaying = useAppSelector((state) => {
    return state.saveReminder.show;
  });
  const dispatch = useAppDispatch();
  const hasMounted = useIsMounted();

  const getWrapperClasses = (): string => {
    return `radius-8 ${styles.wrapper}
     ${currentLoading.show ? styles.in : styles.out} 
     ${hasMounted.current ? styles.doAnimate : ''} 
     ${isSaveReminderDisplaying || loadingToast.isSaveReminderDisplaying ? styles.displayingSaveReminder : ''}
     ${loadingToast.isProgressBarDisplaying ? styles.displayingProgressBar : ''}`;
  };

  const getBottomForLoadingToast = (): string => {
    const DEFAULT_PADDING_AND_GAP = 16;
    const PROGRESS_BAR_HEIGHT = 64;
    const DEFAULT_SAVE_REMINDER_HEIGHT = 137;
    let bottom = DEFAULT_PADDING_AND_GAP;

    if (loadingToast.isProgressBarDisplaying) {
      bottom += PROGRESS_BAR_HEIGHT;
    }

    if (isSaveReminderDisplaying || loadingToast.isSaveReminderDisplaying) {
      bottom += DEFAULT_SAVE_REMINDER_HEIGHT + DEFAULT_PADDING_AND_GAP;
    }

    return `${bottom}px`;
  };

  const onClose = (): void => {
    dispatch(hideLoadingAction(currentLoading.key));
  };

  return (
    <div
      style={{
        bottom: getBottomForLoadingToast(),
      }}
      className={getWrapperClasses()}
    >
      <Toast
        type={ToastType.LOADING}
        title={currentLoading.text}
        progress={currentLoading.progress ? currentLoading.progress * 100 : undefined}
        onClose={!currentLoading.hideIcon ? onClose : undefined}
        progressBarClasses={currentLoading.variant === LoadingVariant.AI ? styles.aiProgressBar : undefined}
        titleClasses={currentLoading.variant === LoadingVariant.AI ? 'ai-text-dark' : undefined}
        circularLoaderColor={currentLoading.variant === LoadingVariant.AI ? LOADER_COLOR.AI_DARK : undefined}
      />
    </div>
  );
}
